/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Access_Title6Inputs */

const en_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission-aware access`)
};

const ar_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول واع بالأذونات`)
};

const bn_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমতি-সচেতন অ্যাক্সেস`)
};

const de_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungsbewusster Zugriff`)
};

const es_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso con permisos`)
};

const fr_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès conscient des permissions`)
};

const pt_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso com permissões`)
};

const zh_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限感知访问`)
};

const tr_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetkili erişim`)
};

const ru_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ с учётом прав`)
};

const pl_svc_rag_knowledge_assistants_access_title6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp z uprawnieniami`)
};

/**
* | output |
* | --- |
* | "Permission-aware access" |
*
* @param {Svc_Rag_Knowledge_Assistants_Access_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_access_title6 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Access_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Access_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_access_title6(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_access_title6(inputs)
	return en_svc_rag_knowledge_assistants_access_title6(inputs)
});
export { svc_rag_knowledge_assistants_access_title6 as "svc_rag-knowledge-assistants_ACCESS_title" }